import HandlersIndex from './handlers_index.js';

class Handlers {
  constructor(){
    const idx = new HandlersIndex();

    this.renderers = idx.renderers;
    this.handlers = idx.handlers;
  }

  getData(){
    return window.__handlers;
  }

  getHandlers(item){
    const handlers = [];
    if(!item.pagemap) return handlers;
    const keys = Object.keys(item.pagemap);
    for(var i = 0; i < keys.length; i++){
      for(var j = 0; j < this.getData().handlers.length; j++){
        if(this.getData().handlers[j]['hook'] === keys[i]){
          var h = this.getData().handlers[j];
          var r = this.getRenderer(h['renderer']);
          var e = this.getExtractor(h['extractor'])
          handlers.push({
            name : h['hook'],
            type : r.type,
            renderer : r,
            extractor: e,
          });
        }
      }
    }

    return handlers;
  }

  getRenderer(name){
    var r = this.renderers.find(item => {return (item.meta === name) ? item : null});
    if(!r || r === null){
      console.log("handlers", "ERROR", "Renderer not found", name);
    }

    return r;
  }

  getExtractor(name){
    var e = this.handlers.find(item => {return (item.meta === name) ? item : null}); 
    if(!e || e === null){
      console.log("handlers", "ERROR", "Extractor not found", name);
    }
    return e;
  }

  getRenderers(){
    var items = [];
    this.renderers.map(item =>{
      items.push({name: item.meta, type: item.type})
    })
    return items;
  }

  getExtractors(){
    var items = [];

    this.handlers.map(item =>{
      items.push(item.meta)
    })

    return items;
  }
}

export default Handlers;



// WEBPACK FOOTER //
// ./src/search/admin/handlers.js